import type { ReactElement } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "../providers/AuthProvider";
import { sanitizeRedirectPath } from "../utils/navigation";

interface ProtectedRouteProps {
  children: ReactElement;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { accessToken } = useAuth();
  const location = useLocation();

  if (!accessToken) {
    const attemptedPath = sanitizeRedirectPath(
      `${location.pathname}${location.search}${location.hash}`
    );
    const loginSearch = attemptedPath ? `?next=${encodeURIComponent(attemptedPath)}` : "";

    return <Navigate to={`/login${loginSearch}`} replace state={{ from: location }} />;
  }

  return children;
}
